import { render } from "./SortVariant.vue?vue&type=template&id=4bf2dd4a"
import script from "./SortVariant.vue?vue&type=script&lang=js"
export * from "./SortVariant.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__